module.exports = __webpack_public_path__ + "img/blog3.8b0a7055.jpg";